import React from "react";

const iconLink =
  "inline-flex items-center justify-center w-8 h-8 rounded-md text-gray-500 hover:text-[#064E8D] hover:bg-gray-100 transition-colors no-underline";
const iconDanger =
  "inline-flex items-center justify-center w-8 h-8 rounded-md text-gray-500 hover:text-red-600 hover:bg-red-50 transition-colors";

/**
 * Action links for active users when rendered inside a separate React root (DataTables cell).
 * Uses `getNavigate` so SPA navigation works without Router context in that root.
 */
const FreightActiveUserDtActions = ({ row, onDeactivate, getNavigate }) => {
  const id = row?.id;
  if (id == null) return null;

  const go = (path) => {
    const nav = getNavigate?.();
    if (typeof nav === "function") {
      nav(path);
      return;
    }
    window.location.assign(path);
  };

  return (
    <div className="flex items-center justify-center gap-0.5 flex-wrap">
      <a
        href={`/freight/active_users/${id}/edit`}
        className={iconLink}
        title="Edit user"
        onClick={(e) => {
          e.preventDefault();
          go(`/freight/active_users/${id}/edit`);
        }}
      >
        <i className="fas fa-pen text-sm" aria-hidden />
      </a>
      <a
        href={`/freight/active_users/${id}/profiling`}
        className={iconLink}
        title="Profiling"
        onClick={(e) => {
          e.preventDefault();
          go(`/freight/active_users/${id}/profiling`);
        }}
      >
        <i className="fas fa-sliders-h text-sm" aria-hidden />
      </a>
      <a
        href={`/freight/active_users/${id}/rm`}
        className={iconLink}
        title="RM"
        onClick={(e) => {
          e.preventDefault();
          go(`/freight/active_users/${id}/rm`);
        }}
      >
        <i className="fas fa-map-marked-alt text-sm" aria-hidden />
      </a>
      <button
        type="button"
        className={iconDanger}
        title="Deactivate user"
        onClick={() => onDeactivate?.(id)}
      >
        <i className="fas fa-user-slash text-sm" aria-hidden />
      </button>
    </div>
  );
};

export default FreightActiveUserDtActions;
